import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Chip,
  Paper,
  Badge,
} from '@mui/material';
import { Warning, ArrowForward } from '@mui/icons-material';
import { InvestmentChecklistTaskDTO } from '@inversor-hub/types';
import { PHASE_CONFIG } from './checklist-constants';
import { getDaysOverdue } from './checklist-utils';

interface OverdueTasksDialogProps {
  open: boolean;
  onClose: () => void;
  tasks: InvestmentChecklistTaskDTO[];
  onGoToTask: (task: InvestmentChecklistTaskDTO) => void;
}

const OverdueTasksDialog = ({ open, onClose, tasks, onGoToTask }: OverdueTasksDialogProps) => {
  // Sort tasks by most overdue first
  const sortedTasks = [...tasks].sort((a, b) => {
    if (!a.dueAt || !b.dueAt) return 0;
    return getDaysOverdue(b.dueAt) - getDaysOverdue(a.dueAt);
  });

  const handleGoToTask = (task: InvestmentChecklistTaskDTO) => {
    onGoToTask(task);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={2}>
          <Warning sx={{ color: 'error.main' }} />
          <Typography variant="h6" component="span" fontWeight={700}>
            Tareas Vencidas
          </Typography>
          <Badge badgeContent={tasks.length} color="error" sx={{ ml: 1 }} />
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        {sortedTasks.length === 0 ? (
          <Box textAlign="center" py={4}>
            <Typography color="text.secondary">No hay tareas vencidas</Typography>
          </Box>
        ) : (
          <Box display="flex" flexDirection="column" gap={2}>
            {sortedTasks.map((task) => {
              const phaseConfig = PHASE_CONFIG[task.phase];
              const daysOverdue = task.dueAt ? getDaysOverdue(task.dueAt) : 0;

              return (
                <Paper
                  key={task.id}
                  variant="outlined"
                  sx={{
                    p: 2,
                    borderLeft: 4,
                    borderLeftColor: 'error.main',
                  }}
                >
                  <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={1}>
                    <Chip
                      label={phaseConfig.label}
                      size="small"
                      sx={{
                        bgcolor: phaseConfig.color,
                        color: 'white',
                        fontWeight: 600,
                      }}
                    />
                    <Typography variant="body2" color="error.main" fontWeight={600}>
                      Vencida hace {daysOverdue} {daysOverdue === 1 ? 'día' : 'días'}
                    </Typography>
                  </Box>

                  <Typography variant="subtitle1" fontWeight={600} mb={1}>
                    {task.label}
                  </Typography>

                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="body2" color="text.secondary">
                      Asignado a: {task.assignedTo === 'psi' ? 'PSI' : 'Inversor'}
                    </Typography>
                    <Button
                      size="small"
                      endIcon={<ArrowForward />}
                      onClick={() => handleGoToTask(task)}
                    >
                      Ir a fase de la tarea
                    </Button>
                  </Box>
                </Paper>
              );
            })}
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cerrar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default OverdueTasksDialog;
